var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#F7B89E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.533 21.715l-5.72 5.723L18 28l.563-2.812 5.723-5.723a1.585 1.585 0 0 1 2.24-.002c.002 0 .002.001.003.002l.007.006c.618.62.617 1.625-.003 2.244zM15 24h-5c-.621 0-1-.379-1-1V9c0-.621.57-1.063 1.19-1.063L22 8c.621 0 1.125.504 1.125 1.125l-.066 6.625M15 12h4M13.25 16H19M13 20h4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f1baebc0cee09d918411e12f8489d874.svg";
export { ForwardRef as ReactComponent };